export default {
    colors: {
        black: '#131010',
        primary: '#1C6EBEE3',
        secondary: '#20DF8ACC'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.secondary,
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black,
        hrBackgroundColor: colors.primary,

        buttonMainBg: colors.secondary,
        buttonMainText: colors.white,
        buttonMainBorder: colors.secondary,
        buttonMainHoverBg: colors.secondary,
        buttonMainHoverText: colors.white,
        buttonMainHoverBorder: colors.secondary,

        partnerCardEbonValidateCartBackgroundColor: colors.secondary,
        partnerCardEbonValidateCartTextColor: colors.white,
        partnerCardEbonValidateCartBorderColor: colors.secondary
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/omeavieTheme.js